import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AccountingLineItemSchema = withDefaults({
  type: 'accounting-line-item',
  objectExtensions: ['accounting-line-item'],
  fields: [
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'lineItemType',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'date',
    },
    {
      kind: 'attribute',
      name: 'period',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'tier',
    },
    {
      kind: 'attribute',
      name: 'validationErrors',
    },
    {
      kind: 'attribute',
      name: 'validationState',
    },
    {
      kind: 'belongsTo',
      name: 'accountingInvoice',
      type: 'accounting-invoice',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'plan',
      type: 'plan',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default AccountingLineItemSchema;
